export default function jwtUser() {
  const user = JSON.parse(sessionStorage.getItem('user'));

  if (user && user.accessToken) {
    // return { Authorization: 'Bearer ' + user.accessToken }; // for Spring Boot back-end
    // return { 'x-access-token': user.accessToken };   // {}, for Node.js 
    //return { username: user.username, 'x-access-token': user.accessToken };
    return { username: user.username, teachername: user.teachername, 'x-access-token': user.accessToken, firstLanguage: user.firstLanguage };
    //return user;  // x
  } else {
    return '';  // not {}
  }
}
